import React from 'react'
import ThemeProvider from '@material-ui/styles/ThemeProvider'
import theme from '@shapr/react-shared/themes/default'
import ChildrenTypes from '@shapr/react-shared/types/Children'
import { Router, } from 'react-router-dom'
import history from '@shapr/react-shared/utils/history'

import GlobalProvider from '~/providers/GlobalProvider'

const AppProvider = props => {
  const { children, } = props
  return (
    <GlobalProvider>
      <ThemeProvider theme={theme}>
        <Router history={history}>{children}</Router>
      </ThemeProvider>
    </GlobalProvider>
  )
}

AppProvider.propTypes = {
  children: ChildrenTypes.isRequired,
}

export default React.memo(AppProvider)
